var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-indicator-wrapper"},_vm._l((_vm.steps),function(index){return _c('span',{key:index,class:'step-indicator-badge' + (index <= _vm.value ? ' active' : '') + (_vm.size ? ` badge-${_vm.size}` : '')})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }